import { Clock } from "excalibur";
import { BaseFlow } from "./baseFlow";
import { IFlow } from "./types";

export class InitialFlow extends BaseFlow<void> {
  constructor(clock: Clock, flow: IFlow<unknown>) {
    super(clock);
    InitialFlow.setNextFlow(flow);
  }
}
